import { Grid } from '@mui/material';
import { useReducer, useState, useEffect } from 'react';
import './App.css';
import ResultElements from './Components/ResultElements';
import VisualSearch from './Components/VisualSearch';
import LoadImg from './Pages/LoadImg';

function App(props) {
  const [selectedImage, setSelectedImage] = useState(null);
  const [items, setItems] = useState(null);
  const [interLoading, setInterLoading] = useState(true)
  const [api, setApi] = useState();
  const [showRes, setShowRes] = useState(true)

  const initialState = {
    price: 1000,
    sex: 'All',
    category: []
  };

  const [state, updateState] = useReducer(
    (state, updates) => ({ ...state, ...updates }),
    initialState
  );

  useEffect(() => {
    if (props.website && props.public_token)
      setApi(new window.Visidea.Api(props.website, props.public_token));
  }, [props]);

  return (
    <div className="App">
      {
        selectedImage && api.conf !== undefined ?
          <Grid container spacing={1} sx={{flexDirection: 'row-reverse'}}>
            <Grid item sx={{width: {xs:'100%'} }}>
              <VisualSearch
                image={selectedImage} 
                selectImage={setSelectedImage} 
                setItems={setItems}
                setFilters={updateState}
                filter={state}
                load={setInterLoading}
                interLoading={interLoading}
                api={api}
                user_id={props.user_id}
                sx={{width: {sm:'300px',lg:'500px'}}}
                setShow={setShowRes}
              />
            </Grid>
            
            <Grid item sx={{width: {xs:'100%',sm:'calc(100% - 300px)',lg:'calc(100% - 500px)'}, 
              height: '100vh', overflow: 'auto', paddingTop: '0!important',  display: showRes ? 'block' : 'none'}}>
              <ResultElements items={items} filter={state}
                interLoad={interLoading} api={api} user_id={props.user_id}/>
            </Grid>
          </Grid>
          :
          <LoadImg selectImage={setSelectedImage} api={api} />
      }
    </div>
  );
}

export default App;
